import { createRouter, createWebHashHistory } from "vue-router";
import { createNavigationGuards } from "./guards";
// 功能页面
const modules = import.meta.glob("./modules/**/*.js", { eager: true });
const routeModuleList = [];

// 加入到路由集合中
Object.keys(modules).forEach(key => {
  const mod = modules[key].default || {};
  const modList = Array.isArray(mod) ? [...mod] : [mod];
  routeModuleList.push(...modList);
});
const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "loginHome",
      meta: {
        isAdmin: false,
      },
      component: () => import("@/views/client/homepage/index.vue"),
      children: [
        {
          path: "",
          name: "login",
          components: {
            rightContent: () => import("@/views/client/component/login.vue")
          }
        },
        {
          path: "/forgetPwd",
          name: "forgetPwd",
          components: {
            rightContent: () => import("@/views/client/component/forgetPwd.vue")
          }
        },
      ],
    },
  ],
});

createNavigationGuards(router);

export default router;
